var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_4794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12582 15.25C2.59416 15.25 2.11082 14.7667 2.15916 14.1867L2.20749 12.64C1.04749 12.4467 0.17749 11.4317 0.17749 10.2717V3.16667C0.17749 1.81333 1.24082 0.75 2.59416 0.75H13.3725C14.7258 0.75 15.7892 1.81333 15.7892 3.16667V10.2717C15.7892 11.625 14.7258 12.6883 13.3725 12.6883H7.13749L3.60916 15.1533C3.46416 15.2017 3.31916 15.25 3.12582 15.25ZM2.64249 1.71667C1.82082 1.71667 1.19249 2.345 1.19249 3.16667V10.2717C1.19249 11.1417 1.91749 11.77 2.73916 11.7217C3.02916 11.7217 3.22249 11.9633 3.22249 12.205L3.12582 14.2833L6.70249 11.8183C6.79916 11.77 6.89582 11.7217 6.99249 11.7217H13.3725C14.1942 11.7217 14.8225 11.0933 14.8225 10.2717V3.16667C14.8225 2.345 14.1942 1.71667 13.3725 1.71667H2.64249ZM7.71749 7.71C7.66916 7.66167 7.62082 7.565 7.57249 7.42L7.23416 4.665C7.08916 3.69833 8.82916 3.69833 8.63582 4.665L8.29749 7.37167C8.34582 7.75833 7.95916 7.90333 7.71749 7.71ZM7.52416 9.35333C6.94416 8.725 7.81416 7.75833 8.49082 8.38667C9.07082 9.06333 8.15249 9.98167 7.52416 9.35333Z",
    fill: "#AAB6CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_4794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIco);
export default __webpack_public_path__ + "static/media/report-ico.3fe7ddb47148009b6ba1a9100dc2c987.svg";
export { ForwardRef as ReactComponent };